import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';
import '../appointment/daily';
import '../appointment/weekly';
import '../appointment/monthly';
import '../deadline/extend';
import '../deadline/delegate';
import '../calendar/calendar';
import '../note/notes';
import { DataTableViewModel, IntermediateListItem, Color } from '../dataTable/dataTable';
import { Utils } from '../../utils';
import * as moment from "moment"
import "../../../node_modules/moment/locale/de.js";
import * as fs from 'fs';

export class DashboardViewModel {
    appointments = ko.observableArray([]);
    deadlines = ko.observableArray([]);
    resubmissions = ko.observableArray([]);
    todos = ko.observableArray([]);
    lastWorkedOn = ko.observableArray([]);
    isempty = ko.observable("-/-");
    isemptyDate = ko.observable("TT.MM.JJJJ")

    defaultSachbearbeiter = ko.observable();


  
 
    //akteFrist = ko.observableArray([]);

    readonly DANGER_COLOR: Color = {
        color: "white",
        "background-color": "#e21b38" //be4259
    }

    currentView: KnockoutObservable<String>;

    viewTypes = [{ name: "Tagesansicht", view: "daily-view" }, { name: "Wochenansicht", view: "weekly-view" }];
    selectedType = ko.observable(this.viewTypes[0].view);

    pickedWeekDate = ko.observable(moment.utc().startOf("day"));

    today = () => this.pickedWeekDate(moment.utc().startOf("day"));

    nextInterval = () => {
        if (this.selectedType() === "weekly-view") {
            this.pickedWeekDate(this.startOfDay().clone().add(1, "week"))
        } else {
            this.pickedWeekDate(this.startOfDay().clone().add(1, "day"))
        }
    }

    previousInterval = () => {
        if (this.selectedType() === "weekly-view") {
            this.pickedWeekDate(this.startOfDay().clone().subtract(1, "week"))
        } else {
            this.pickedWeekDate(this.startOfDay().clone().subtract(1, "day"))
        }
    }

    startOfDay = ko.computed(() => {
        let weekDate = this.pickedWeekDate().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            return weekDate.startOf("week");
        } else {
            return weekDate;
        }
    });

    endOfDay = ko.computed(() => {
        let weekDate = this.pickedWeekDate().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            let startOfWeek = weekDate.startOf("week");
            return startOfWeek.clone().add(4, "days").endOf("day");
        } else {
            return weekDate.endOf("day");
        }
    });

    intervalText = ko.computed(() => {
        let startOfDay = this.startOfDay().clone();
        let endOfDay = this.endOfDay().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            return `KW ${startOfDay.format("W")} \u2013 ${startOfDay.format("D. MMMM")} bis ${endOfDay.format("D. MMMM YYYY")}`;
        } else {
            return startOfDay.format("D. MMMM YYYY");
        }
    });

    startOfThisMonth: moment.Moment;
    startOfNextMonth: moment.Moment;

    deadlineToBeModified = ko.observable(null);

    constructor(params: any) {
        moment.locale("de");
        this.currentView = ko.observable(params.view);

        this.endOfDay.subscribe(() => this.update());

        this.startOfThisMonth = moment.utc().startOf("month");
        this.startOfNextMonth = moment.utc().startOf("month").add(1, "month");
        
        this.update();


        this.getDefaultSachbearbeiter();
        
    }

    async getDefaultSachbearbeiter() {
        let sach = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(d => d.Sachbearbeiter_ID === RNSAPI.User().username);
        this.akteFrist().SachbearbeiterId(sach[0].Sachbearbeiter_ID);
        this.akteFrist().Sachbearbeiter(sach[0].Sachbearbeiter);
    }

    public getVM = () => this;

    public showAppointments() {
        MainViewModel.RoutingTable.showDashboardView({ view: "appointments" }, true);
        //Tab change funktion bootstrap
        this.currentView('appointments');
    }

    public showTodos() {
        MainViewModel.RoutingTable.showDashboardView({ view: "todos" }, true);
        this.currentView('todos');
    }

    public showLastWorkedOn() {
        MainViewModel.RoutingTable.showDashboardView({ view: "lastworkedon" }, true);
        this.currentView('lastworkedon');
    }

    transformAppointmentData(obj: any, type: string) {
        let color = Utils.isToday(moment.utc(obj.StartDate)) && !obj.Completed ? this.DANGER_COLOR : undefined;
        let actionList = [
            { icon: "pencil-alt", name: "Edit", action: () => MainViewModel.RoutingTable.showAppointmentView({ id: obj.Id }) },
            { icon: "trash-alt", name: "Löschen", action: async () => { await RNSAPI.deleteAppointment(obj.Id); this.update(); } },
        ];

        if (!obj.Completed) {
            actionList.push({ icon: "check", name: "Abhaken", action: async () => { await RNSAPI.completeAppointment(obj.Id); this.update(); } });
        }

        return new IntermediateListItem(type, nameTable[type], obj.StartDate, obj.AppointmentSubject, obj.CaseId, obj, actionList, color);
    }

    transformDeadlineData(obj: any, type: string) {
        let check = { icon: "check", name: "Abschließen", action: async () => { await RNSAPI.completeDeadline(obj); this.update(); } };
        //let check = { icon: "check", name: "Abschließen", action: async () => console.log("adfasdfdasf") };

        let actionList = [
            {
                icon: "pencil-alt", name: "Verlängern", action: async () => {
                    this.deadlineToBeModified(obj);
                    $('#extendDeadline').modal('show');
                }
            },
            {
                icon: "user-circle", name: "Delegieren", action: async () => {
                    this.deadlineToBeModified(obj);
                    $('#delegateDeadline').modal('show');
                }
            },
        ];

        if (obj.CompletionDate === null) actionList.push(check);
        var DeadlineX = Number(moment(obj.Deadline).format("YYYYMMDD"));
        var Heutee = Number(moment(moment()).format("YYYYMMDD"));//moment(moment().format("YYYY-MM-DD")).format("X"));
        var OneDay = 86400;        


        if (obj.PreDeadline !== null)
        {
            if (DeadlineX > Heutee) {
                var PreDeadlineX = Number(moment(moment(obj.PreDeadline).format("YYYY-MM-DD")).format("YYYYMMDD"));
                type = "predeadline";
                let color = PreDeadlineX < Heutee ? this.DANGER_COLOR : undefined;
                return new IntermediateListItem(type, nameTable[type], obj.PreDeadline, obj.TypeId + obj.TypeDescription, obj.CaseId, obj, actionList, color);
            }
            else
            {
                let color = Utils.isToday(moment.utc(obj.Deadline)) ? this.DANGER_COLOR : undefined;
                return new IntermediateListItem(type, nameTable[type], obj.Deadline, obj.TypeId + obj.TypeDescription, obj.CaseId, obj, actionList, color);
            }
        }
        else {
            let color = Utils.isToday(moment.utc(obj.Deadline)) ? this.DANGER_COLOR : undefined;
            return new IntermediateListItem(type, nameTable[type], obj.Deadline, obj.TypeId + obj.TypeDescription, obj.CaseId, obj, actionList, color);
        }        
    }

    transformResubmissionData(obj: any, type: string) {
        let color = Utils.isToday(moment.utc(obj.DeadLineDate)) ? this.DANGER_COLOR : undefined;
        return new IntermediateListItem(type, nameTable[type], obj.DeadLineDate, obj.DeadLineReason, obj.Case_ID || obj.Sachbearbeiter, obj, [
            { icon: "pencil-alt", name: "Edit", action: async () => MainViewModel.RoutingTable.showResubmissionView({ id: obj.ID }) },
            { icon: "trash-alt", name: "Löschen", action: async () => { await RNSAPI.deleteResubmission(obj.ID); this.update(); } },
        ], color);
    }

    transformECasesData(obj: any, type: string) {
        return new IntermediateListItem(type, nameTable[type], obj.LastChange || obj.DocumentDate || obj.RecordDate, obj.Subject, obj.CaseId, obj, [
            { icon: "pencil-alt", name: "Edit", action: async () => MainViewModel.RoutingTable.showCaseEntryView({ caseId: obj.CaseId, eCaseRecordId: obj.Id }) },
            { icon: "trash-alt", name: "Löschen", action: async () => { await RNSAPI.deleteRecord(obj.Id); this.update(); } },

            { icon: "eye", name: "Betrachten", action: async () => { MainViewModel.RoutingTable.showCaseEntriesView({ caseId: obj.CaseId, eCaseRecordId: obj.Id }) } },
        ]);
    }

    transformZPEData(obj: any, type: string) {
        return new IntermediateListItem(type, nameTable[type], obj.EMailDate, obj.Subject, obj.Sender, obj, [
            { icon: "eye", name: "Betrachten", action: async () => { MainViewModel.RoutingTable.showMailView({ accountId: obj.EMailAccountID, mailId: obj.RNSMail_ID }) } },
        ]);
    }

    async updateAppointments(allAppointments: any) {
        try {
            let appointments = allAppointments.Payload.Appointments.map(a => ({ ...a })).filter((a: any) => a.AppointmentType !== "F");
            let transformed = appointments.map(obj => {
                obj.actionHandlers = [
                    { icon: "pencil-alt", name: "Edit", action: () => MainViewModel.RoutingTable.showAppointmentView({ id: obj.Id }) },
                    { icon: "trash-alt", name: "Löschen", action: async () => { await RNSAPI.deleteAppointment(obj.Id); this.update(); } },
                ];
                return obj;
            });
            this.appointments(transformed);
        } catch (e) {
            console.log("Could not retrieve appointments.");
            console.log(e);
        }
    }

    async updateDeadlines(allDeadlines: any) {
        try {
            let deadlines = allDeadlines.Payload.Deadlines.map(d => ({ ...d })).filter(d => d.CompletionDate === null);
            let deadlinesSorted = deadlines.sort((d1, d2) => {
                if (moment.utc(d1.Deadline).isBefore(moment.utc(d2.Deadline))) {
                    return 1;
                } else {
                    return -1;
                }
            });
            var DeletedItems = 0;
            let transformed = deadlinesSorted.map(obj => {
                let copy = $.extend(true, {}, obj);
                obj.columnActions = {
                    "CaseId": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.CaseId)}`)
                };
                obj.actionHandlers = [
                    {
                        icon: "pencil-alt", name: "Verlängern", action: async () => {
                            this.deadlineToBeModified(copy);
                            $('#extendDeadline').modal('show');
                        }
                    },
                    {
                        icon: "user-circle", name: "Delegieren", action: async () => {
                            this.deadlineToBeModified(copy);
                            $('#delegateDeadline').modal('show');
                        }
                    },
                    { icon: "check", name: "Abschließen", action: async () => { await RNSAPI.completeDeadline(copy); this.update(); } }
                ];

                //obj.Deadline = (new Date(obj.Deadline)).toLocaleDateString();
                obj.Deadline = moment(obj.Deadline).format("DD.MM.YYYY");

                //obj.PreDeadline = obj.PreDeadline ? (new Date(obj.PreDeadline)).toLocaleDateString() : "";
                obj.PreDeadline = obj.PreDeadline ? moment(obj.PreDeadline).format("DD.MM.YYYY") : "Keine Vorfrist";

                obj.TypeDescription = obj.TypeId + obj.TypeDescription;
                
                var Today = Number(moment().format("YYYYMMDD"));
                var FristTimestamp = Number(moment(obj.Deadline, "DD.MM.YYYY").format("YYYYMMDD"));
                
                //Herausfilern von Terminen
                if (Today < FristTimestamp) {
                    if (obj.PreDeadline !== "Keine Vorfrist") {
                        var PreFrTimestamp = Number(moment(obj.PreDeadline, "DD.MM.YYYY").format("YYYYMMDD"));
                        if (Today < PreFrTimestamp) {
                            DeletedItems++;
                            return 0;
                        }
                        else {
                            obj.color = PreFrTimestamp < Today ? this.DANGER_COLOR : undefined;
                        }
                    }
                    else
                    {
                        DeletedItems++;
                        return 0;
                    }
                }
                else {
                    obj.color = FristTimestamp < Today ? this.DANGER_COLOR : undefined;
                }
                return obj;
            });

            this.TermiCount(Number(transformed.length - DeletedItems));
            this.deadlines(transformed);
            
        } catch (e) {
            console.log("Could not retrieve deadlines.");
            console.log(e);
        }
    }

    async updateTodos(start: Date, end: Date, allAppointments: any, allDeadlines: any) {
        try {

            var Heutee = moment().format("DD.MM.YYYY");

            let zpeMails = (await RNSAPI.getZPE()).Payload.Emails;
            let transformedZPEEMails = zpeMails.map((zpeMail) => this.transformZPEData(zpeMail, "inbox"));

            for (var i = 0; i <= transformedZPEEMails.length - 1; i++) {

                if (transformedZPEEMails[i].date !== Heutee) {
                    transformedZPEEMails.splice(i, 1);
                }
            }

            let appointments = allAppointments.Payload.Appointments.filter((a: any) => a.AppointmentType !== "F" && !a.Completed)
            let deadlines = allDeadlines.Payload.Deadlines.filter(d => d.CompletionDate === null);

            let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
            let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline"));
            let resubmissions = (await RNSAPI.getResubmissionsByRange({ StartDate: start.toISOString(), EndDate: end.toISOString() })).Payload.Resubmissions;
            let transformedResubmissions = resubmissions.map(obj => this.transformResubmissionData(obj, "resubmission"));
            let ecases = (await RNSAPI.getCaseEntriesForWorkFlow("PE")).Payload.Records;
            let transformedECases = ecases.map(obj => this.transformECasesData(obj, "ecase"));
            let todos = (transformedAppointments.concat(transformedDeadlines)
                .concat(transformedResubmissions)
                .concat(transformedZPEEMails)
                .concat(transformedECases));
            let sortedTodos = todos.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
                if (t1.dateObj.isBefore(t2.dateObj)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            //console.log(sortedTodos);
        
            let transformed = sortedTodos.map(obj => {
                let copy = $.extend(true, {}, obj);

                var Today = Number(moment().format("YYYYMMDD"));
                for (var i = 0; i <= sortedTodos.length - 1; i++) {
                            
                    var temp = moment(sortedTodos[i].date, "DD.MM.YYYY").format("YYYYMMDD");
                    var FristTimestamp = Number(temp);

                    if (FristTimestamp > Today) {
                        sortedTodos.splice(i, 1);
                    }

                    //if (sortedTodos[i].entryTypeName !== "Posteingang") {
                    sortedTodos[i].color = FristTimestamp < Today ? this.DANGER_COLOR : undefined;
                    //}

                    if (sortedTodos[i].entryTypeName === "Frist" || sortedTodos[i].entryTypeName === "EAkte" || sortedTodos[i].entryTypeName === "Vorfrist") {
                        sortedTodos[i].columnActions = {
                            "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(sortedTodos[i].number)}`)
                        };
                    }
                }            
                
                return obj;
                               
            });



            this.todos(sortedTodos);
       
        } catch (e) {
            console.log("Could not retrieve todos.");
            console.log(e);
        }
    }

    //async updateLastWorkedOn(start: Date, end: Date) {
      async updateLastWorkedOn() {

        //'date', 'number', 'subject'

        /*
         let allAppointments = await RNSAPI.getAppointments(start, end);
         let appointments = allAppointments.Payload.Appointments.filter((a: any) => a.AppointmentType !== "F" && a.Completed)

         this.lastWorkedOn(transformed);
        */

        let cases = (await RNSAPI.getLastCases(10)).Payload.Cases;
        //console.log(cases);
        //for (var i = 0; i < cases.lenght(); i++) {
        //    cases[i].date = "19.11.2018";
        //    cases[i].entryTypeName = "Test";
        //    cases[i].
        //}

          let transformed = cases.map(obj => {
              let copy = $.extend(true, {}, obj);
              

              // "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(sortedTodos[i].number)}`)

              obj.actionHandlers = [
                  {
                      icon: "info-circle", name: "Informationen", action: async () => {
                          //this.deadlineToBeModified(copy);
                          //$('#extendDeadline').modal('show');
                      }
                  }
              ];



              for (var i = 0; i < cases.length; i++) {
                  if (cases[i].number === "NULL") {
                      cases[i].number = "-"
                  } else {
                      //obj.columnActions = {

                      //    "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.number)}`)
                      //};
                  }
              }
           

            return obj;


        });
        this.lastWorkedOn(transformed);
        //this.lastWorkedOn(cases);




        //try {
        //    let allAppointments = await RNSAPI.getAppointments(start, end);
        //    let appointments = allAppointments.Payload.Appointments.filter((a: any) => a.AppointmentType !== "F" && a.Completed)
        //    let deadlines = (await RNSAPI.getDeadlines(moment(start))).Payload.Deadlines.filter(d => d.CompletionDate !== null);
        //    let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
        //    let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline"));
        //    let resubmissions = (await RNSAPI.getResubmissionsByRange({ StartDate: start.toISOString(), EndDate: end.toISOString() })).Payload.Resubmissions;
        //    let transformedResubmissions = resubmissions.map(obj => this.transformResubmissionData(obj, "resubmission"));
        //    let lastWorkedOn = (transformedAppointments.concat(transformedDeadlines)
        //        .concat(transformedResubmissions));
        //    let lastWorkedOnSorted = lastWorkedOn.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
               
        //        if (t1.dateObj.isBefore(t2.dateObj)) {
        //            return 1;
        //        } else {
        //            return -1;
        //        }
        //    });

        //    let transformed = lastWorkedOnSorted.map(obj => {
        //        let copy = $.extend(true, {}, obj);
        //        obj.columnActions = {
        //            "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.number)}`)
        //        };
        //        return obj;
        //    });
        //    this.lastWorkedOn(transformed);
        //    this.lastWorkedOn(lastWorkedOnSorted);
        //} catch (e) {
        //    console.log("Could not retrieve lastWorkedOn.");
        //    console.log(e);
        //}
    }

    async update() {
        let allAppointments = await RNSAPI.getAppointments(this.startOfDay().toDate(), this.endOfDay().toDate())
        let allDeadlines = await RNSAPI.getDeadlines(this.startOfDay());
        this.updateAppointments(allAppointments);
        this.updateDeadlines(allDeadlines);
        this.updateTodos(this.startOfDay().toDate(), this.endOfDay().toDate(), allAppointments, allDeadlines);
        //this.updateLastWorkedOn(this.startOfDay().clone().subtract(1, 'days').toDate(), this.endOfDay().clone().subtract(1, 'days').toDate());
        this.updateLastWorkedOn();
    }

    newAkteFrist() {
        let obj = {
            SachbearbeiterId: ko.observable(RNSAPI.User().username),
            Sachbearbeiter: ko.observable(null),
            CaseId: ko.observable(null),
            Rubrum: ko.observable("Kein Rubrum vorhanden."),
            DeadlineNumber: ko.observable("-/-"),
            DeadlineText: ko.observable(null),
            PreDeadline: ko.observable(),
            StartDate: ko.observable(moment().format("YYYY-MM-DD")),
            TheDeadline: ko.observable()
        };
        //console.log(RNSAPI.getSachbearbeiter());
        return ko.observable(obj);
    };

    akteFrist = this.newAkteFrist();
    basicDeadline = this.akteFrist;
    IsDeadlineNecessary = ko.observable(true);

    async submit() {
        this.postData();
    };    

    async postData() {
        $(".form-group").each(function () { $(this).removeClass("has-error"); });
        let deadlineObj = ko.toJS(this.akteFrist());
        console.log(deadlineObj.CaseId);    

        try {
            let result = await RNSAPI.createDeadline(deadlineObj);
            if (result.Type === "CreationSuccessful") {
                //MainViewModel.RoutingTable.showDashboardView({ view: "appointments" });
                let allDeadlines = await RNSAPI.getDeadlines(this.startOfDay());
                RNSAPI.createHistoryEntry(deadlineObj.CaseId, "Frist angelegt"); 
                this.updateDeadlines(allDeadlines);
                this.updateLastWorkedOn();
                $('#NewDeadlineDialog').modal('hide');        
            } else {
                alert("Fehler beim Anlegen der Frist.");
            }
        } catch (e) {
            console.log(e);
            alert("Fehler beim Anlegen: " + e.responseText);
        }
    };

    pickSachbearbeiter = async () => {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Sachbearbeiter", ["Sachbearbeiter"], ["Sachbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.akteFrist().SachbearbeiterId(selectedObject()["Sachbearbeiter_ID"]); //selectedObject()["Sachbearbeiter_ID"]
            this.akteFrist().Sachbearbeiter(selectedObject()["Sachbearbeiter"])
        });
        $('#modal').modal('show');
    };

    async pickCase() {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akte", ["Registernummer", "Rubrum", "Wegen"], ["Registernummer", "Rubrum", "Wegen"], cases);
        this.modalHandleSelection((selectedObject) => {
            this.akteFrist().CaseId(selectedObject()["Registernummer"]);
            this.akteFrist().Rubrum(selectedObject()["Rubrum"])
            //this.akteFrist().SachbearbeiterId(selectedObject()["SachbearbeiterId"]); //Sachbearbeiter ändern
            //this.akteFrist().Sachbearbeiter("");
        });
        $('#modal').modal('show');
    };

    async pickDeadlineNumber() {
        let reasons = (await RNSAPI.getDeadlineReasons()).Payload.Reasons;
        this.pickGeneric("Grund", ["DeadlineDescription"], ["Beschreibung"], reasons);
        this.modalHandleSelection((selectedObject) => {
            this.akteFrist().DeadlineNumber(selectedObject()["DeadlineNumber"]);
            this.akteFrist().DeadlineText(selectedObject()["DeadlineDescription"])

            if (selectedObject().DeadlineDuration.startsWith("w")){
                let weeks = selectedObject().DeadlineDuration[1] + selectedObject().DeadlineDuration[2];
                let today = moment().format("YYYY-MM-DD");
                let FristDay = moment(today).add(weeks, "w");
                this.akteFrist().TheDeadline(FristDay.format("YYYY-MM-DD"));
            }
            else if (selectedObject().DeadlineDuration.startsWith("m")) {
                let months = selectedObject().DeadlineDuration[1] + selectedObject().DeadlineDuration[2];
                let today = moment().format("YYYY-MM-DD");
                let FristDay = moment(today).add(months, "M");
                this.akteFrist().TheDeadline(FristDay.format("YYYY-MM-DD"));
            }
            else if (selectedObject().DeadlineDuration.startsWith("j")) {
                let year = selectedObject().DeadlineDuration[1] + selectedObject().DeadlineDuration[2];
                let today = moment().format("YYYY-MM-DD");
                let FristDay = moment(today).add(year, "y");
                this.akteFrist().TheDeadline(FristDay.format("YYYY-MM-DD"));
            }
            else
            {
                //Kein Präfix = Wochen
            }
        });
        $('#modal').modal('show');
    };

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();
    TermiCount = ko.observable(0);

    akte = ko.observable({
        Registernummer: ko.observable(null),
        Referat: ko.observable(null),
        SachbearbeiterId: ko.observable(null),
        Rubrum: ko.observable(null),
        Wegen: ko.observable(null),
        Sachstand: ko.observable(null),
        AnlageDatum: ko.observable(moment().format("DD.MM.YYYY")),
        Note1: ko.observable(null),
        Wiedervorlage: ko.observable(""),
        WertGericht1: ko.observable(0),
        IsSelected: ko.observable(true)
    });
}


let nameTable: { [key: string]: string; } = {
    "appointment": "Termin",
    "deadline": "Frist",
    "predeadline":"Vorfrist",
    "inbox": "Posteingang",
    "resubmission": "Wiedervorlage",
    "ecase": "EAkte"
};

var html = fs.readFileSync(__dirname + '/dashboard.html', 'utf8');

ko.components.register("dashboard-view", {
    viewModel: DashboardViewModel,
    template: html
});
